"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M15.605 9.405a.7.7 0 0 1 .99 0L18.2 11.01l1.605-1.605a.7.7 0 0 1 .99.99L19.19 12l1.605 1.605a.7.7 0 0 1-.99.99L18.2 12.99l-1.605 1.605a.7.7 0 0 1-.99-.99L17.21 12l-1.605-1.605a.7.7 0 0 1 0-.99M12.213 6.31c0-.718-.875-1.072-1.375-.555l-3.15 3.26a2.7 2.7 0 0 1-1.942.824H5.2a.8.8 0 0 0-.8.8v2.723a.8.8 0 0 0 .8.8h.546a2.7 2.7 0 0 1 1.942.823l3.15 3.26a.8.8 0 0 0 1.375-.556zM9.831 4.783c1.374-1.422 3.782-.45 3.782 1.529V17.69c0 1.978-2.408 2.951-3.782 1.529l-3.15-3.26a1.3 1.3 0 0 0-.935-.396H5.2a2.2 2.2 0 0 1-2.2-2.2V10.64a2.2 2.2 0 0 1 2.2-2.2h.546a1.3 1.3 0 0 0 .935-.397z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=UnmuteIcon24.js.map